import 'lazysizes'
import { addScript } from 'js/mobile/common/intersection-loader-script'

// Shows the follow button when bellow the fold
const observer = new IntersectionObserver((entries, observer) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) {
      return
    }

    import('js/mobile/common/cookie-consent.js')

    const $webpushProvider = document.getElementById('webpush-provider')

    if ($webpushProvider.value === 'webpushr') {
      addScript('webpushr', 'webpushr-jssdk')
    } else {
      addScript($webpushProvider.value)
    }    
  })
}, {
  rootMargin: '0px 0px -100% 0px'
});